export const MinRowsForUsingVirtuoso = 20;
